<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<script>

import {ViewModeEnum} from "@/utils/helpers";
import ViewModeComponent from "@/core/components/ViewModeComponent.vue";
import {plainToClass} from "@qwoach/class-transformer-wrapper";

export default {
	name: "BaseWizardStep",
	extends: ViewModeComponent,

	props:{
		stepGlobalData: null,
		wizardData: {Object, default: () => ({})},
		stepIdProp: String,
		savedState: null,
		title: String,
		asyncHandler: null, //need to pass it from WizardLayout so the variable of "isLoading" is updated on the correct instance. Otherwise loading indicator won't show up during data loading
		viewMode: {ViewModeEnum, default: "ADD"},
	},

	async mounted(){
		// let asyncHandler = this.asyncHandler || this.handleAsync
		// // let asyncHandler = this.$parent.$parent.handleAsync// || this.handleAsync
		//
		// await this.restoreStateInternal()
		// this.onRestoreStateFinished()
		// await asyncHandler(() => this.loadData())
	},

	methods:{

		async restoreStateInternal(){
			let asyncHandler = this.asyncHandler || this.handleAsync
			if(this.savedState){
				console.log("restoreState mounted")
				await asyncHandler(async () => this.restoreState(this.savedState))
			}
			await this.restoreGlobalStateInternal()
		},

		async restoreGlobalStateInternal(){
			let asyncHandler = this.asyncHandler || this.handleAsync
			if(this.stepGlobalData){
				console.log("restoreStateGlobal")
				await asyncHandler(async () => this.restoreStateGlobal(this.stepGlobalData))
			}
		},

		stepId(){
			if(this.stepIdProp){
				return this.stepIdProp
			}
			throw new Error("BaseWizardStep: stepId() is not implemented yet")
		},

		onRestoreStateFinished(){
			this.$emit("onRestoreStateFinished")
		},

		async restoreState(savedState){

		},
		async restoreStateGlobal(savedState){

		},
		async saveState(){
			return this.getStepData()
		},

		async loadData(){

		},

		async onSkipClicked(){
		},

		async onNextClicked(){
		},

		getStepData(){
			return this.stepData
		},

		createDefaultStepData(){
			return {}
		},
		stepDataClass(){
			return null
		},

		async saveStepDataGlobal(incomingGlobalData){
			return incomingGlobalData
		},

		async onPrevClicked(){
		},

		async validateStep(){
			return this.validateForm()
		},

		async onStepEnteredInternal(){
			console.log("BaseWizardStep.onStepEnteredInternal: this = ", this)
			let _ = this.$analyticManager.trackEvent("Step entered", {step_title: this.title, ...this.analyticsPropsMethod()})

			let asyncHandler = this.asyncHandler || this.handleAsync
			await this.restoreStateInternal()
			this.onRestoreStateFinished()
			await asyncHandler(() => this.loadData())

			await this.onStepEntered()
		},

		async onStepEntered(){

		},

		isStepRequired(){
			return true
		},

		hideActionButtons(){
			return false
		},
		hideNextActionButton(){
			return false
		},

		getProgressText(){
			return this.progressText
		},

		getProgressSaveText(){
			return "Saving..."
		},

		stepDescription(){
			return ""
		},

		showActionPanel(show){
			this.$emit("showActionPanel", show)
		},

		showLoading(show, text){
			this.$emit("showLoading", show, text)
		},

		nextStep(){
			this.$emit("nextStep")
		},
		prevStep(){
			this.$emit("prevStep")
		},
		skipStep(){
			this.$emit("skipStep")
		},

		getWizardDataByStepId(stepId){
			return this.wizardData[stepId]
		},

		getTitle(){
			return this.title
		},

		stepDataEnsureClass(data){
			let stepId = this.stepId()
			let dataClass = this.stepDataClass()
			console.log("BaseWizardStep.stepDataEnsureClass: stepId = ", stepId, ", data = ", data, ", dataClass = ", dataClass)
			if(dataClass && !(data instanceof dataClass)){
				data = plainToClass(dataClass, data)
				// eslint-disable-next-line vue/no-mutating-props,vue/no-side-effects-in-computed-properties
				this.wizardData[stepId] = data
			}
			return data
		},



	},

	computed: {
		stepData: {
			get() {
				let stepId = this.stepId()
				let data = this.wizardData[stepId]
				if(!data){
					data = this.createDefaultStepData()
					// eslint-disable-next-line vue/no-mutating-props,vue/no-side-effects-in-computed-properties
					this.wizardData[stepId] = data
				}
				data = this.stepDataEnsureClass(data)
				return data
			},

			set(value) {
				value = this.stepDataEnsureClass(value)
				let stepId = this.stepId()
				// eslint-disable-next-line vue/no-mutating-props,vue/no-side-effects-in-computed-properties
				this.wizardData[stepId] = value
				this.$emit("update:stepData", value)
			}

		}
	},
}
</script>

<style lang="scss">

</style>
